import { createAction } from '@reduxjs/toolkit'
import {
   CHANGE_LANG,
   GET_BANNERS,
   REMOVE_BANNER,
   SAVE_BANNERS,
   SET_BANNERS,
   SET_BANNER_STATE
} from './const'
import { TRemoveGridBannerPayload, TSaveGridBannersPayload } from './types'

export const gridActions = {
   changeLang: createAction(CHANGE_LANG, (payload) => ({ payload })),
   getBanners: createAction(GET_BANNERS, (payload) => ({ payload })),
   setBanners: createAction(SET_BANNERS, (payload) => ({ payload })),
   removeBanner: createAction(REMOVE_BANNER, (payload: TRemoveGridBannerPayload) => ({
      payload
   })),
   saveBanners: createAction(SAVE_BANNERS, (payload: TSaveGridBannersPayload) => ({
      payload
   })),
   setBannerState: createAction(SET_BANNER_STATE, (payload) => ({ payload }))
}
